import React, {useEffect} from 'react';
import { useTranslation } from 'react-i18next';
import mainbg from 'images/mainbg.png';
import styled from 'styled-components';
import { Banner } from 'components';
import classNames from 'classnames';
import { NavLink } from 'react-router-dom';

const FilterDiv = styled.div`
	width: 100vw;
	padding: 40px;
	background-image: url(${mainbg});
	background-repeat: no-repeat;
	background-size: cover;
	background-position: center center;
	position: relative;
`;

const LayerColor = styled.div`
	height: 100%;
	width: 100%;
	position: absolute !important;
	top: 0;
	left: 0;
	background-color: rgba(3, 71, 129, 0.6);
	z-index: 20;
`;

const Title = styled.div`
	z-index: 100;
`;

const Blue = styled.span`
	color: ${props => props.theme.darkBlue};

	a, a.active {
		color: ${props => props.theme.darkBlue} !important;
		font-family: "PT Sans";
	}
`;

const InteractionBetweenSystems = () => {
	const { t } = useTranslation();

	useEffect(() => window.scrollTo(0, 0), []);

	return (
		<>
			<FilterDiv className='block-fullwidth padding-40'>
				<LayerColor />
				<Title className='color-white col-1 font-24 font-bold text-center text-uppercase'>{t('Взаимодействие между системами')}</Title>
			</FilterDiv>
			<Banner />

			<div className='container flex column align-center padding-40'>
				<div className={classNames('item', 'col-1', 'margin-bottom-20', 'pt-sans', 'font-16', 'font-bold')}>
					{t('Взаимодействие между системами осуществляется по протоколу HTTPS, данные отправляются в форматах XML (основной) или JSON.')}
				</div>
				<div className={classNames('item', 'col-1', 'margin-bottom-20', 'pt-sans', 'font-16')}>
					{t('Для работы с API необходимо сообщить свой пул IP-адресов, для добавления в список разрешенных на стороне acase.ru. Авторизация происходит по логину и паролю. Для получения доступа и добавления IP-адресов обратитесь по адресу ')} <Blue><a href="mailto:support@acase.ru" className='text-underline'>support@acase.ru</a></Blue>
				</div>
				<div className={classNames('item', 'col-1', 'margin-bottom-20', 'pt-sans', 'font-16', 'font-bold')}>
					{t('Для целей разработки и тестирования следует использовать URL:')}
				</div>
				<div className={classNames('item', 'col-1', 'margin-bottom-20', 'pt-sans', 'font-16')}>
					{'TEST API:'} <Blue>{'https://test-api.acase.ru/xml/form.jsp'}</Blue>
				</div>
				<div className={classNames('item', 'col-1', 'margin-bottom-20', 'pt-sans', 'font-16')}>
					{'PROD API:'} <Blue>{'https://api.acase.ru/xml/form.jsp'}</Blue>
				</div>
				<div className={classNames('item', 'col-1', 'margin-bottom-20', 'pt-sans', 'font-16', 'font-16')}>
					{t('Для отправки данных в формате XML используется HTTP-метод POST, а XML-данные включаются в тело запроса. Заголовок запроса должен содержать: Content-Type: application/x-www-form-urlencoded. Сервисы бывают двух типов,  тело запроса должно быть сформировано следующим образом: ключ с именем XML и значением:')}
				</div>
				<div className={classNames('item', 'col-1', 'margin-bottom-20', 'pt-sans', 'font-16', 'font-bold')}>
					{t('1. "Имя сервиса" и "Набор параметров", например, для сервиса')} <Blue><NavLink to={'/method/ClientCategoryList'}>{'ClientCategoryListRequest:'}</NavLink></Blue>
				</div>
				<div className={classNames('item', 'col-1', 'margin-bottom-20', 'pt-sans', 'font-16')}>
					{'RequestName=ClientCategoryListRequest&CompanyId="MyCompanyId"&UserId="MyUserId"&Password="MyPassword"&Language="ru"'}
				</div>
				<div className={classNames('item', 'col-1', 'margin-bottom-20', 'pt-sans', 'font-16', 'font-bold')}>
					{t('2. "Имя сервиса" и XML-параметр, например, для сервиса')} <Blue><NavLink to={'/method/OrderList'}>{'OrderListRequest:'}</NavLink></Blue>
				</div>
				<div className={classNames('item', 'col-1', 'margin-bottom-20', 'pt-sans', 'font-16')}>
					{'RequestName=OrderListRequest&XML=<OrderListRequest BuyerId="MyCompanyId" UserId="MyUserId" Password="MyPassword" Language="ru" RegistrationDateFrom="01.01.2025" RegistrationDateTo="31.01.2025"/>'}
				</div>
				<div className={classNames('item', 'col-1', 'margin-bottom-20', 'pt-sans', 'font-16')}>
					{t('Для целей разработки используйте наш тестовый сайт')} <Blue><NavLink to='https://test-www.acase.ru' target="_blank" rel="noreferrer">test-www.acase.ru</NavLink>.</Blue>
				</div>
			</div>
		</>
	);
};

export default InteractionBetweenSystems;